import React from "react"

export default React.createContext({ onMessage: () => null, closeMessage: () => null })
